import React from 'react';
import { SpriteFourStep, SpriteTwoStep } from "../routes/Experimental";

import poke073 from "../images/bulba/073.png"
import poke082 from "../images/bulba/082.png"
import poke123 from "../images/bulba/123.png"
import poke197 from "../images/bulba/197.png"
import poke252 from "../images/bulba/252.png"
import poke255 from "../images/bulba/255.png"
import poke258 from "../images/bulba/258.png"
import poke377 from "../images/bulba/377.png"
import poke378 from "../images/bulba/378.png"
import poke379 from "../images/bulba/379.png"
import poke380 from "../images/bulba/380.png"
import poke381 from "../images/bulba/381.png"
import poke382 from "../images/Large/382.png"
import poke383 from "../images/Large/383.png"
import poke384 from "../images/Large/384.png"
import poke385 from "../images/bulba/385.png"
import poke386 from "../images/bulba/386.png"
import poke386_0 from "../images/bulba/386_0.png"
import poke386_1 from "../images/bulba/386_1.png"
import poke386_2 from "../images/bulba/386_2.png"
import poke386_3 from "../images/bulba/386_3.png"

export const PokeRender = (props) => {
  const [count, setCount] = React.useState(0);
  const [count2, setCount2] = React.useState(0);

  const requestRef = React.useRef();
  const previousTimeRef = React.useRef();

  window.addEventListener("keydown", function (e) {
    if (["Space", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"]
      .indexOf(e.code) > -1) {
      e.preventDefault();
    }
  }, false);

  const animate = time => {
    if (previousTimeRef.current !== undefined) {
      const deltaTime = time - previousTimeRef.current;

      // This last mod is the range
      // the decimal is speed of animation
      setCount(prevCount => (prevCount + deltaTime * 0.0035) % 3);
      setCount2(prevCount => (prevCount + deltaTime * 0.001) % 1);
    }
    previousTimeRef.current = time;
    requestRef.current = requestAnimationFrame(animate);
  }

  React.useEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  });

  let frame = Math.round(count);
  let frame1 = Math.round(count2);
  let frame2 = frame1 === 0 ? 1 : 0;

  let direction = "0" // down
  let inverse_direction = "3" // up
  let directionName = "Down" // front

  if (props.direction === "left key detected.") {
    direction = 1;
    inverse_direction = 2;
    directionName = "Left"
  } else if (props.direction === "right key detected.") {
    direction = 2;
    inverse_direction = 1;
    directionName = "Right"
  } else if (props.direction === "up key detected.") {
    direction = 3;
    inverse_direction = 0;
    directionName = "Up"
  } else {
    direction = 0;
    inverse_direction = 3;
    directionName = "Down"
  }

  const images = require.context('../images/bulba', true);
  const imageList = images.keys().map(image => images(image));

  const debug = false

  return (
    <div>
      {
        !debug ? "" : <>
          <br />
          {"Direction: " + directionName}
          <br />
          {"4step: " + frame}
          <br />
          {"2Step: " + frame1}
          <br />
        </>
      }

      <br />
      <br />

      {/* walking  */}
      {SpriteFourStep(frame, imageList[0], 0, direction)}
      {SpriteFourStep(frame, imageList[1], 0, direction)}
      {SpriteFourStep(frame, imageList[2], 0, direction)}
      <br />
      <br />
      {SpriteFourStep(frame, imageList[3], 0, direction)}
      {SpriteFourStep(frame, imageList[4], 0, direction)}
      {SpriteFourStep(frame, imageList[5], 0, direction)}
      <br />
      {SpriteFourStep(frame, imageList[6], 0, direction)}
      {SpriteFourStep(frame, imageList[7], 0, direction)}
      {SpriteFourStep(frame, imageList[8], 0, direction)}
      <br />
      <br />
      {SpriteFourStep(frame, imageList[59], 0, direction)}
      {SpriteFourStep(frame, imageList[60], 0, direction)}
      {SpriteFourStep(frame, imageList[61], 0, direction)}
      <br />
      <br />
      {SpriteFourStep(frame, imageList[24], 0, direction)}
      {SpriteFourStep(frame, imageList[149], 0, direction)}
      {SpriteFourStep(frame, imageList[156], 0, direction)}
      <br />
      {SpriteFourStep(frame, imageList[90], 0, direction)}
      {SpriteFourStep(frame, poke386, 0, direction)}
      {SpriteFourStep(frame, imageList[142], 0, direction)}
      <br />
      <br />
      <br />
      <br />

      {/* nonwalking  2s */}
      {SpriteTwoStep(frame1, poke123, 0, direction)}
      {SpriteTwoStep(frame2, poke082, 0, direction)}
      {SpriteTwoStep(frame1, poke197, 0, direction)}
      <br />
      <br />
      {SpriteTwoStep(frame1, poke073, 0, direction)}
      {SpriteTwoStep(frame2, poke252, 0, direction)}
      {SpriteTwoStep(frame1, poke255, 0, direction)}
      {SpriteTwoStep(frame2, poke258, 0, direction)}

      <br />
      <br />
      {SpriteTwoStep(frame1, poke377, 0, direction)}
      {SpriteTwoStep(frame2, poke378, 0, direction)}
      {SpriteTwoStep(frame1, poke379, 0, direction)}
      {SpriteTwoStep(frame2, poke380, 0, direction)}
      {SpriteTwoStep(frame1, poke381, 0, direction)}
      {SpriteTwoStep(frame2, poke385, 0, direction)}

      <br />
      <br />
      {SpriteTwoStep(frame2, poke386_0, 0, direction)}
      {SpriteTwoStep(frame2, poke386_1, 0, inverse_direction)}
      {SpriteTwoStep(frame2, poke386_2, 0, direction)}
      {SpriteTwoStep(frame2, poke386_3, 0, inverse_direction)}

      <br />
      <br />
      {SpriteTwoStep(frame2, poke383, 0, direction, 2)}
      {SpriteTwoStep(frame1, poke382, 0, direction, 2)}
      {SpriteTwoStep(frame2, poke384, 0, direction, 2)}

      {SpriteTwoStep(frame2, imageList[247+27], 0, direction, 2)}
      {SpriteTwoStep(frame2, imageList[248+27], 0, direction, 2)}

      <br />
      <br />
      <br />
      <br />

      {/* TODO - use this to figure out scaling issue */}
      {/* {SpriteFourStep(frame, imageList[9], 1, direction)} */}

      {imageList.map((image, index) => (
        <div key={index} style={{display: "inline"}}>
          {/* gen 2 split  */}
          {index === 151 ? (<><br /><br /><br /><br /><br /></>) : ""}
          {/* gen 3 split  */}
          {index === 277 ? (<><br /><br /><br /><br /><br /></>) : ""}
          {/* gen 4 split  */}
          {index === 416 ? (<><br /><br /><br /><br /><br /></>) : ""}

          {/* shinny split  */}
          {index === 546 ? (<><br /><br /><br /><br /><br /></>) : ""}

          {/* shinny gen2 split  */}
          {index === 697 ? (<><br /><br /><br /><br /><br /></>) : ""}
          {/* shinny gen3 split  */}
          {index === 823 ? (<><br /><br /><br /><br /><br /></>) : ""}
          {/* shinny gen4 split  */}
          {index === 960 ? (<><br /><br /><br /><br /><br /></>) : ""}


          {/* alternate spacing */}
          {index % 13 === 0 ? (<br />) : <></>}


          {/* TODO - try to remove this skipping code by fixing the sprites */}
          {
            // gen1 skipping bug
            index === 9 || index === 38 || index === 73 ||

              // gen1 skipping bug - steelix
              index === 233 ||

              // gen2 skipping bug - leg birds
              // index === 274 || index === 275 ||

              // gen 3 - skipping bug
              index === 346 || index === 358 ||

              // gen 3 - skipping bug - legendaries
              index === 407 || index === 408 || index === 409 ||

              // gen 4 - skipping bug - legendaries
              index === 518 || index === 519 ||
              index === 521 || index === 522 ||
              (index > 527 && index <= 544) ||



              // gen 2 shiny - legendaries skipping bug
              index === 779 ||
              index === 820 || index === 821 ||

              // gen 3 shiny - skipping bug
              index === 904 || index === 892 ||

              // gen 3 - shiny legendaries
              index === 953 || index === 954 || index === 955 ||

              // gen 4 - shiny legendaries
              index === 1062 || index === 1063 || index === 1065 || index === 1066 ||


              // glitched
              index > 1071 ||
              index === 9999

              ?
              <></> :
              <>
                {!(index === 274 || index === 275) ? (
                  <>
                    {SpriteFourStep(frame, image, 0, direction)}
                  </>
                ) : (
                  <>
                    {SpriteTwoStep(frame, image, 0, direction, 2)}
                  </>
                )}
              </>
          }
        </div>
      ))}

      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />

    </div>
  )
};
